// extracted by mini-css-extract-plugin
export var settingsList = "_3f-0";
export var settingsRow = "_3f-1";
export var warningDot = "_3f-2";